import Online from "../../assets/imgs/online.gif";
import Offline from "../../assets/imgs/offline.gif";
import { useDispatch } from "react-redux";
import { getPlayerInWeb } from "../../store/reducers/reducerWeb";
import { useEffect, useState } from "react";
import "../centerPages/Guild/Guild.scss";

const GetPlayerOnlineForGuildInfo = ({ name }) => {
  const dispatch = useDispatch();
  const [state, setState] = useState();
  useEffect(() => {
    async function getStatusPlayer() {
      return dispatch(
        await getPlayerInWeb({
          playername: name,
        })
      ).then((res) => {
        return setState(res.payload[0].ConnectStat);
      });
    }

    getStatusPlayer();
  }, [name]);

  return (
    <td>
      <img src={state == 1 ? Online : Offline} alt="" />
    </td>
  );
};

export default GetPlayerOnlineForGuildInfo;
